/* import __COLOCATED_TEMPLATE__ from './walkthrough-popover.hbs'; */
var _dec, _dec2, _class;
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * `appointments-walkthrough-popover` is a variant of `sq-walkthrough-popover`, customized for the appointments calendar.
 *
 * See sq-walkthrough-popover.js in the onboarding addon for reference documentation.
 *
 * Parameters
 * @param {string} classNameBindings - Classes for the component. We don't use `class` so that Walkthrough can manage the dynamic classes.
 * @param {boolean} isActive - If the popover is active.
 * @param {Object} step - The WalkthroughStep the popover is showing.
 * @param {String} step.text - The main text which appears in the popover.
 * @param {String} step.subtext - The body text which appears in the popover. If empty, doesn't render body text.
 * @param {String} step.buttonText - The text for the "Next" button of the popover. If empty, the button will not render.
 * @param {String} step.imageUrl - The url for an image in the popover. If empty, the image will not render.
 * @param {String} step.imageAltText - The alt text for the image in the popover. If empty, the image will not render.
 * @param {boolean} step.showProgressText - Whether or not the step will show the progress text
 * @param {boolean} step.emphasizeClose - Whether or not to emphasize the close button on the tooltip
 * @param {string} [progressText] - Optional string (step.showProgressText) in footer to indicate what the number of the current step out of the total number.
 * @param {action} [next] - Optional action for the button rendered with step.buttonText
 * @param {action} [close] - Optional action (shouldShowCloseButton) for the close icon on the popover.
 */

import { classNames, classNameBindings } from '@ember-decorators/component';
import SqPopoverComponent from '@square/glass-ui/components/sq-popover';
let WalkthroughPopover = (_dec = classNames('appointments-walkthrough-popover', 'popover--walkthrough', 'popover--popper'), _dec2 = classNameBindings('popoverClassNames'), _dec(_class = _dec2(_class = class WalkthroughPopover extends SqPopoverComponent {
  constructor(...args) {
    super(...args);
    // Passed in from Walkthrough
    _defineProperty(this, "popoverClassNames", null);
    _defineProperty(this, "close", null);
    _defineProperty(this, "next", null);
    _defineProperty(this, "step", null);
    _defineProperty(this, "isActive", null);
    _defineProperty(this, "progressText", null);
  }
}) || _class) || _class);
export { WalkthroughPopover as default };